import React from "react";
import { useState, useContext } from "react";
import {useNavigate } from "react-router-dom";
import '../content/base_2.0.css';
import '../content/ccbh-tableau-portal_2.0.css';
import './login.css';

import configData from "../config/config.json";
import {BeatLoader} from "react-spinners";
import AuthContext from "../context/authContext";
import PageLogoHeader from "./pageLogoHeader";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";

import LoginVerificationModal from "./loginVerificationModal";
import {ClientJS} from "clientjs";
//import {checkDeviceRegistration, registerDevice} from "../helpers/updateAccountInformation";

function LoginForm({loginMsg}) {
    let navigate = useNavigate();

    const {login} = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [loginResult, setLoginResult] = useState(false);
    const [loginError, setLoginError] = useState(loginMsg);
    const [userName, setUserName] = useState('');
    const [userPassword, setUserPassword] = useState('');

    const [openLoginVerificationModal, setOpenLoginVerificationModal] = useState(false);
    const [verificationResult, setOpenLoginVerificationResult] = useState();
    //const [verificationCode, setVerificationCode] = useState(0);
    let loginTime = null;
    
    const goDashboardList = (loginResp) => {
        navigate("/dashboardlist", {state: {id:1, name:'test', loginResult: loginResp}});
    }

    const goFirstTimeLogin = (loginResp) => {
        navigate("/firsttime",{state: {id:2, loginResult: loginResp}});
    }

    const goToCzarPage = (loginResp) => {
        navigate("/czar", {state: {id:3, loginResult: loginResp}});
    }

    function handleUsernameKeyUp(event){
        //event.preventDefault();
        if(loginError !== ""){
            setLoginError("");
        }
    };

    const handleUsernameBlur = (event) => {
        setUserName(event.currentTarget.value);
    }

    function handlePasswordKeyUp(event){
        if(loginError !== ""){
            setLoginError("");
        }else if (event.key === 'Enter'){
            handleSubmit(event);
        }
    }

    function handlePasswordBlur(event){
        setUserPassword(event.currentTarget.value);
    };
    
    const getLoginResult = async(url, username, password, fingerprint, browser, os, device) => {
        try{
            var Buffer = require('buffer/').Buffer;
            const authHeaderValue = "Basic " + new Buffer.from(username + ':' + password).toString('base64');
            console.log(authHeaderValue);
            
            const response = await fetch(url, { 
                method:"POST",
                headers: {'Authorization':authHeaderValue,
                          'Content-Type': 'application/json',
                          'Access-Control-Allow-Origin':'*'},
                body:JSON.stringify({
                "webuserId": username,
                "fingerPrint": String(fingerprint),
                "deviceprint": browser + "-" + os + "-" + device
            }),
                });
            console.log(response);
            const responseJson = await response.json();

            return responseJson; 
        }catch(err){
            console.error(err.message);
            console.debug(err);
            console.debug(err.stack);
        }
    };

    const handleSubmit= async(event) =>{
        //var url = 'https://swcctbwb5001/?username=' + userName + '&password=' + password;
        if(userName !== "" && userPassword !==""){
            loginTime = new Date();
            setLoading(true);
            const cj = new ClientJS();
            console.log(cj.getFingerprint());
            console.log(cj.getBrowser());
            console.log(cj.getOS());
            console.log(cj.getDevice());
            var url = configData.CCBHTableauAPIServer + "/login"; //     'http://localhost:5000/';

            const loginResponse = await getLoginResult(url, userName, userPassword, cj.getFingerprint(), cj.getBrowser(), cj.getOS(), cj.getDevice());

            if(loginResponse === undefined || loginResponse.success === false){
                setLoginError("Username or password is incorrect");
                setLoading(false);
            }else if (loginResponse.message == "account locked"){
                setLoginError("The Account has been locked for too many failed attempts. Please contact CCBH: DataMine DataMine@ccbh.com for assistance.");
                setLoading(false);
            }else if(loginResponse.success === true){
                setLoginResult(false);
                
                let verificationResult = true;

                setUserName();
                setUserPassword();
                setLoginError("Verification Failed.");
                setLoading(false);
                setTimeout(() => {window.location.reload();}, 3000);

                //1 day in milliseconds
                const OneDay = (1000*60*60*24);
                const Today = new Date().getTime();
                const UserAddedDay = new Date(loginResponse.user.origEntryChron).getTime();
                const DayDiff = Today - UserAddedDay;
                const Datediff = Math.round(DayDiff/OneDay);
                console.log('Datediff:', Datediff);

                if(Datediff > 0){
                    var msg = "Redirect user " +  loginResponse.user.firstName + " " + loginResponse.user.lastName +  " to: " + loginResponse.sitePage.siteName;
                    setLoginError(msg);
                    login();

                    if(loginResponse.message === "first login"){
                        goFirstTimeLogin(loginResponse);
                    }else if(loginResponse.user.isCzar){
                        goToCzarPage(loginResponse);
                    }else{
                        goDashboardList(loginResponse);
                    }
                }else{
                    setLoading(false);
                    ccbhmessagebox({
                        message: "Your account was just created you need to wait till the next day to access the site.",
                        title: "New Account Access",
                        modal: true,
                        closebutton: false,
                        buttons:{
                            'Ok': function(){
                                removeMsg();
                                navigate("/");
                            }
                        }
                    });
                }
            }
        }
     };

     const spinnerCSS = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        zAxis: 999,
     };
   
     
    
    return(
        <>
        <div className="wrapper">
            <div id="pagebody">
               <PageLogoHeader /> 

                <div className="login" id="login"  >
                    <div id="uname_password_div">
                        <input type="text" autoComplete="off" id="username" onKeyUp={handleUsernameKeyUp} onChange={handleUsernameBlur} onBlur={handleUsernameBlur} defaultValue={userName} required  />
                        <label id="user_name_label" className="label">Username</label>
                        <br /><br />
                        <input type="password" autoComplete="off" id="password" onKeyUp={handlePasswordKeyUp} onChange={handlePasswordBlur} onBlur={handlePasswordBlur} defaultValue={userPassword} required  />
                        <label id="password_label" className="label">Password</label>
                        <br />
                        <label className="login-message">{loginError}</label>
                    </div>
                    <div id="button_div">
                        <button type={"submit"} className="save_button" id="login_button" onClick={handleSubmit}>Login</button>
                    </div>
                    <div id="login_loader">
                        <BeatLoader 
                            color="#762d6a"
                            loading={loading}
                            size={25}
                            aria-label="Logging In"
                            data-testid="loader"
                            cssOverride={spinnerCSS}
                        />
                    </div>
                </div>
                <div id="forgot-password">
                    <a id="forgot-password" href="/passwordrecover">forgot my password</a>
                </div>
            </div>
        </div>

        
        {/*openLoginVerificationModal &&
            <LoginVerificationModal 
                show={!!openLoginVerificationModal}
                onClose={openLoginVerificationModal.onClose}
                onVerify={openLoginVerificationModal.onVerify}
            />
        */}


        </>
    );
};

export default LoginForm;